(() => {
  const valid = cart => Boolean(cart && Number.isSafeInteger(cart.item_count) && cart.item_count >= 0 && Number.isSafeInteger(cart.total_price) && cart.total_price >= 0 && /^[A-Z]{3}$/.test(cart.currency || ''));
  const lockAttributes = ['data-fs-selection-cart-uncertain','data-fs-live-cart-checkout-locked','data-fs-quickview-cart-pending','data-fs-selection-cart-pending','data-fs-quickview-cart-uncertain','data-fs-bag-pending','data-fs-bag-refreshing'];
  const blocked = () => {
    if (lockAttributes.some(name => document.documentElement.hasAttribute(name)) || document.querySelector('.cart__items--disabled, product-form .loading')) return true;
    const builder = document.querySelector('fs-bundle-builder');
    if (builder?.locked || builder?.ready && builder?.busy) return true;
    try { return Boolean(sessionStorage.getItem('fs-bundle-pending-add') || sessionStorage.getItem('fs-live-cart-review')); } catch (_) { return true; }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = { valid, lockAttributes };
  if (typeof window === 'undefined' || customElements.get('fs-pdp-bag-bar')) return;
  class PdpBagBar extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.version = 0;
      this.count = this.querySelector('[data-pdp-bag-count]');
      this.total = this.querySelector('[data-pdp-bag-total]');
      this.checkout = this.querySelector('[data-pdp-bag-checkout]');
      try { this.cart = JSON.parse(this.querySelector('[data-pdp-bag-initial]').textContent); } catch (_) {}
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.render(); }); };
      this.onUpdate = event => {
        this.version++;
        if (this.nativeForm && event?.source === 'product-form' && String(event.productVariantId) === this.nativeVariant) this.nativeOutcome = 'success';
        if (valid(event?.cartData)) { this.cart = event.cartData; this.failed = false; }
        queueMicrotask(this.schedule);
      };
      this.unsubscribe = typeof subscribe === 'function' ? subscribe(PUB_SUB_EVENTS.cartUpdate, this.onUpdate) : null;
      this.onError = event => { if (this.nativeForm && event?.source === 'product-form' && String(event.productVariantId) === this.nativeVariant) this.nativeOutcome = 'rejected'; };
      this.unsubscribeError = typeof subscribe === 'function' ? subscribe(PUB_SUB_EVENTS.cartError, this.onError) : null;
      this.onSubmit = event => {
        const form = event.target.closest('product-form');
        if (!form?.closest('product-info[data-fs-product-page]') || form.querySelector('.loading')) return;
        const variant = form.querySelector('[name="id"]')?.value;
        queueMicrotask(() => {
          if (!form.querySelector('.loading')) return;
          if (this.nativeForm) this.nativeUncertain = true;
          this.nativeForm = form; this.nativeVariant = String(variant); this.nativeOutcome = false; this.nativeBeforeState = this.lastState; this.schedule();
        });
      };
      document.addEventListener('submit', this.onSubmit, true);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.schedule();
      });
      this.observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class','open']});
      this.rootObserver = new MutationObserver(() => { this.version++; this.schedule(); });
      this.rootObserver.observe(document.documentElement, {attributes:true, attributeFilter:lockAttributes});
      this.onLock = () => { this.version++; this.schedule(); };
      document.addEventListener('fs:bag-lock', this.onLock);
      this.onReturn = event => {
        const detail = event.detail;
        if (typeof detail?.current !== 'function' || !detail.current() || !valid(detail.cart)) return;
        this.version++; this.cart = detail.cart; this.failed = false; this.schedule();
      };
      document.addEventListener('fs:cart-return-ready', this.onReturn);
      this.onRestore = event => { if (event.persisted) { this.failed = true; this.schedule(); this.refresh(); } };
      this.onVisible = () => { if (!document.hidden) this.refresh(); };
      window.addEventListener('pageshow', this.onRestore);
      document.addEventListener('visibilitychange', this.onVisible);
      this.onClick = event => {
        const link = event.target.closest('a');
        if (!link || !this.contains(link)) return;
        if (link.matches('[data-pdp-bag-checkout]')) {
          this.render();
          if (this.checkout.getAttribute('aria-disabled') === 'true') { event.preventDefault(); event.stopImmediatePropagation(); }
        }
        if (link.matches('[data-pdp-bag-open]') && !event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
          const drawer = document.querySelector('cart-drawer');
          const destination = new URL(link.href, location.origin);
          if (this.nativeUncertain) {
            destination.searchParams.set('fs_cart_view','full'); destination.searchParams.set('fs_cart_result','review'); link.href = destination.href; return;
          }
          if (destination.searchParams.get('fs_cart_view') === 'full' || drawer?.premium?.reviewPending() || blocked()) return;
          if (typeof drawer?.open === 'function') { event.preventDefault(); drawer.open(link); }
        }
      };
      this.addEventListener('click', this.onClick);
      this.resize = new ResizeObserver(entries => {
        const height = Math.ceil(entries[0].target.getBoundingClientRect().height);
        if (height > 0) document.documentElement.style.setProperty('--fs-pdp-bag-height', `${height}px`);
      });
      this.resize.observe(this.querySelector('.fs-pdp-bag-bar__panel'));
      this.render();
    }
    readDrawer() {
      const node = document.querySelector('cart-drawer [data-fs-bag-state]');
      if (!node || node.textContent === this.lastState) return;
      this.lastState = node.textContent;
      try { const cart = JSON.parse(node.textContent); if (valid(cart)) { this.cart = cart; this.failed = false; } } catch (_) {}
    }
    render() {
      this.readDrawer();
      if (this.nativeForm && !this.nativeForm.querySelector('.loading')) {
        if (!this.nativeOutcome) this.nativeUncertain = true;
        const verify = this.nativeOutcome === 'success' && this.nativeBeforeState === this.lastState;
        this.nativeForm = null;
        if (verify) { this.failed = true; queueMicrotask(() => this.refresh()); }
      }
      const okay = valid(this.cart);
      const count = okay ? this.dataset.countLabel.replace('[count]', this.cart.item_count) : '—';
      const total = okay ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.cart.currency,minimumFractionDigits:this.cart.total_price % 100 ? 2 : 0,maximumFractionDigits:2}).format(this.cart.total_price / 100) : '—';
      if (this.count.textContent !== count) this.count.textContent = count;
      if (this.total.textContent !== total) this.total.textContent = total;
      const disabled = !okay || !this.cart.item_count || this.refreshing || this.failed || this.nativeUncertain || blocked();
      this.checkout.setAttribute('aria-disabled', String(Boolean(disabled)));
      if (disabled) this.checkout.setAttribute('tabindex','-1'); else this.checkout.removeAttribute('tabindex');
    }
    async refresh() {
      if (this.refreshing || blocked()) return;
      const version = ++this.version;
      this.refreshing = true; this.render();
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(this.dataset.cartUrl, {credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:'application/json'}});
        const cart = await response.json();
        if (!response.ok || !valid(cart)) throw new Error('Unconfirmed cart');
        if (version !== this.version || blocked()) return;
        this.cart = cart; this.failed = false;
      } catch (_) { if (version === this.version) this.failed = true; }
      finally { clearTimeout(timer); this.refreshing = false; this.schedule(); }
    }
    disconnectedCallback() {
      this.version++; this.ready = false;
      this.unsubscribe?.(); this.unsubscribeError?.();
      document.removeEventListener('submit', this.onSubmit, true); this.observer?.disconnect(); this.rootObserver?.disconnect(); this.resize?.disconnect();
      cancelAnimationFrame(this.frame); this.frame = 0;
      document.removeEventListener('fs:bag-lock', this.onLock);
      document.removeEventListener('fs:cart-return-ready', this.onReturn);
      window.removeEventListener('pageshow', this.onRestore);
      document.removeEventListener('visibilitychange', this.onVisible);
      this.removeEventListener('click', this.onClick);
    }
  }
  customElements.define('fs-pdp-bag-bar', PdpBagBar);
})();
